import { IconPointFilled } from '@tabler/icons-react';
import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { ContextSidebar } from '@/core/components/RootLayout/Sidebar/ContextSidebar';

export const Route = createFileRoute('/_auth/administration/_administration')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.administration' },
  },
});

function RouteComponent() {
  const { t } = useTranslation();

  const authorTabs = [
    { label: t('sidebar.disciplines'), to: 'discipline', icon: IconPointFilled },
    { label: t('sidebar.departments'), to: 'department', icon: IconPointFilled },
    { label: t('sidebar.faculties'), to: 'faculty', icon: IconPointFilled },
  ];

  return (
    <>
      <ContextSidebar
        baseUrl="administration"
        items={authorTabs}
      />
      <Outlet />
    </>
  );
}
